module.exports = __webpack_public_path__ + "img/partners-logo.daa460df.svg";